/**
 * Browser entry point.
 *
 * Deliberately thin: it mounts the router and nothing else. Every provider lives
 * in `RootLayout` because `Providers` needs router context (`useNavigate`), so
 * wrapping them here would break NextUI's client-side navigation.
 *
 * StrictMode is OFF, matching the Next.js config's `reactStrictMode: false`.
 * The wallet and SUI query effects are not double-invoke safe — StrictMode's
 * second pass fires a duplicate signature prompt.
 */
import "@/styles/globals.css";

import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./router";

const container = document.getElementById("root");

if (!container) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(<RouterProvider router={router} />);
